<template>
    <div class="card">
        <div class="card-content">
            <div class="columns">
                <div class="column is-1 has-text-centered">
                    <p class="main-icon title has-text-danger">
                        <span class="icon">
                           <i class="fas fa-ship"></i>
                        </span>
                    </p>
                </div>
                <div class="column has-text-centered">
                    <p>CARS IN JAPAN </p>
                    <p class="title has-text-primary">{{ inJapan }}</p>
                </div>
                <div class="column has-text-centered">
                    <p>CARS ON TRANSIT </p>
                    <p class="title has-text-primary">{{ onTransit }}</p>
                </div>
                <div class="column has-text-centered">
                    <p>TOTAL CARS PURCHASED</p>
                    <p class="title has-text-primary">{{ total }}</p>
                </div>
                <div class="column has-text-centered">
                    <p>CARS ARRIVED</p>
                    <p class="title has-text-primary">{{ arrived }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
          return {
              inJapan: this.$store.getters.getCurrentUser.cars.in_japan,
              onTransit: this.$store.getters.getCurrentUser.cars.in_transit,
              arrived: this.$store.getters.getCurrentUser.cars.arrived,
              total: this.$store.getters.getCurrentUser.cars.total
          }
        },
        mounted () {

        }
    }
</script>

<style scoped>
    .main-icon {
        font-size: 3rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Exports.vue